import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Checkbox from "./checkbox";
import Form from "./form";
import P from "./p";
import Page from "./page"
import PageHeader from "./pageheader";
import Title from "./title";

export default function BatteryPoweredVideo({ mediaQuery, page, total }) {
  const nextUrl = "/apply/battery-powered-membership/";
  const submitUrl = "/api/applications/v4/application/battery_powered_video/";
  const {
    data: {
      results: [
        {
          submission: {
            battery_powered_video: { completed_video_ind }
          }
        }
      ]
    }
  } = useQuery(["application"]);
  const [form, setForm] = useState({ completed_video_ind, errors: null });
  useEffect(() => {
    const iframe = document.querySelector("iframe");
    if (iframe !== null) {
      const player = new window.Vimeo.Player(iframe);
      player.on("ended", function(data) {
        setForm({ ...form, completed_video_ind: true });
      });
    }
  });
  return (
    <Page>
      <PageHeader title={`APPLICATION PAGE ${page} OF ${total}`} tagline="What is Battery Powered?">
        <P>
          Battery Powered is The Battery’s philanthropy program. It’s a community within The Battery
          of members who want to make the world a better place. Together, members find and fund
          people and projects with a serious chance of making society stronger. Battery Powered is a
          program of The Battery Foundation, a 501 (c) 3 public charity.
        </P>
      </PageHeader>
      <Title>watch the video to learn more</Title>
      <div>
        <iframe
          title="Battery Video"
          src="https://player.vimeo.com/video/240679089"
          webkitallowfullscreen=""
          mozallowfullscreen=""
          allowFullScreen=""
          data-ready="true"
          width={mediaQuery.isTabletOrMobile ? "100%" : "690"}
          height={mediaQuery.isTabletOrMobile ? "" : "518"}
          frameBorder="0"
          byline="0"
        ></iframe>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </div>
      {form?.completed_video_ind === true && (
        <div>
          <P id="message">Thank you for watching the video.</P>
        </div>
      )}
      <Form
        form={form}
        setForm={setForm}
        nextUrl={nextUrl}
        enabled={form?.completed_video_ind === true}
        submitUrl={submitUrl}
      >
        <Checkbox
          style={{ visibility: "hidden" }}
          name="completed_video_ind"
          type="checkbox"
          form={form}
          setForm={setForm}
        />
      </Form>
    </Page>
  );
}
